import '../plugins/load-inview/js/load-inview';

document.addEventListener(
    'DOMContentLoaded',
    function () {
        lazyLoad('[data-src]');
    },
    false
);
